export function setCookie(expiration, name) {
  document.cookie = `${name}=true;expires=${expiration.toUTCString()}`;
}

export function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length >= 2) return parts.pop().split(";").shift();
}
